import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import PublicRoute from "../protectedRoute/publicRoute";
import NotFound from "../common/notFound";
import Cookies from "js-cookie";
import ExamRoutes from "./examRoutes";
import RouteVerification from "../common/routeVerification";
import { EncodeDecode } from "../common/encodeDecode";
import setAuthToken from "../utils/setAuthToken";
import { store } from "../Redux/store";
import examActions from "../Redux/exam/actions";
import ProjectNotFound from "../common/projectNotFound";
import Login from "../pages/login";
import LandingPage from "../pages/landingPage";
import LiveTest from "../pages/liveTest";
import ThankYou from "../common/thankYou";
import Summary from "../pages/summary";
import Practice from "../common/practice";
import EndExam from "../common/endExam";

const AppRoutes = () => {
  const navigate = useNavigate();
  const apiUrl = sessionStorage.getItem("apiUrl");
  const isVenue = sessionStorage.getItem("venue") ?? false;

  if (Cookies.get("test_engine_token")) {
    setAuthToken(Cookies.get("test_engine_token"));
  }

  useEffect(() => {
    const interval = setInterval(() => {
      store.dispatch({ type: examActions.GET_HEART_BEAT });
    }, 1000);

    return () => clearInterval(interval);
  }, [store.dispatch]);

  const CHECK_INTERVAL = 5000;
  const INACTIVITY_LIMIT = 3 * 60 * 1000;

  useEffect(() => {
    localStorage.setItem("lastActive", Date.now().toString());
    const interval = setInterval(() => {
      const lastActive = parseInt(
        localStorage.getItem("lastActive") || "0",
        10
      );
      const now = Date.now();
      if (now - lastActive > INACTIVITY_LIMIT) {
        handleSystemInactive();
      }
      localStorage.setItem("lastActive", Date.now().toString());
    }, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleSystemInactive = () => {
    if (isVenue) {
      Cookies.remove("test_engine_token");
      Cookies.remove("test_engine_project");
      localStorage.removeItem("currentSectionIndexs");
      localStorage.removeItem("remainingTime");
      localStorage.removeItem("isRunning");
      localStorage.removeItem("startTimestamp");
      localStorage.removeItem("updatedQuestionsList");
      localStorage.removeItem("activeSection");
      sessionStorage.removeItem("visitedQuestions");
      sessionStorage.removeItem("cachedQuestionImage");
      sessionStorage.removeItem("cachedQuestionImage");
      sessionStorage.removeItem("lastUpdatedIndex");
      sessionStorage.removeItem("remainingTime");
      navigate(`/login?apiUrl=${apiUrl}`);
      sessionStorage.removeItem("examEnded");
      sessionStorage.removeItem("isEarlyMovedSection");
    } else {
      Cookies.remove("test_engine_token");
      Cookies.remove("test_engine_project");
      localStorage.removeItem("currentSectionIndexs");
      localStorage.removeItem("remainingTime");
      localStorage.removeItem("isRunning");
      localStorage.removeItem("startTimestamp");
      localStorage.removeItem("updatedQuestionsList");
      localStorage.removeItem("activeSection");
      sessionStorage.removeItem("visitedQuestions");
      sessionStorage.removeItem("cachedQuestionImage");
      sessionStorage.removeItem("candidate_details");
      sessionStorage.removeItem("candidate_exam_details");
      sessionStorage.removeItem("lastUpdatedIndex");
      sessionStorage.removeItem("remainingTime");
      sessionStorage.removeItem("examEnded");
      sessionStorage.removeItem("isEarlyMovedSection");

      navigate(`/${Cookies.get("test_engine_project")}/login`);
    }
  };

  return (
    <Routes>
      <Route
        path="*"
        element={
          <PublicRoute>
            <NotFound />
          </PublicRoute>
        }
      />
      <Route
        path="/examination"
        element={
          <PublicRoute>
            <RouteVerification />
          </PublicRoute>
        }
      />
      <Route
        path="/project-not-found"
        element={
          <PublicRoute>
            <ProjectNotFound />
          </PublicRoute>
        }
      />
      <Route path="/en-de" element={<EncodeDecode />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/login" element={<Login />} />
      <Route path="/home" element={<LandingPage />} />
      <Route path="/mock-test" element={<LiveTest />} />
      <Route path="/live-test" element={<LiveTest />} />
      <Route path="/summary" element={<Summary />} />
      <Route path="/practice" element={<Practice />} />
      <Route path="/end-exam" element={<EndExam />} />
      <Route
        path={
          Cookies.get("test_engine_project")
            ? `${Cookies.get("test_engine_project")}/*`
            : "*"
        }
        element={<ExamRoutes />}
      />
    </Routes>
  );
};

export default AppRoutes;
